export default __webpack_public_path__ + "static/media/image-placeholder.d7b3899f.jpg";